import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SidebarPanelBody = props => {
  const {
      children
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    "data-commenting-scroll-container": true
  }, otherProps, {
    children: children
  }));
};
export default SidebarPanelBody;